<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_6495_41325)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M50 100C77.614 100 100 77.614 100 50C100 22.386 77.614 0 50 0C22.386 0 0 22.386 0 50C0 77.614 22.386 100 50 100Z" fill="white" fill-opacity="0.8"/>
<path d="M64.9955 53.711C67.8527 52.0614 67.8527 47.9375 64.9955 46.2879L45.7098 35.1533C42.8527 33.5038 39.2812 35.5657 39.2812 38.8649V61.1341C39.2812 64.4332 42.8527 66.4952 45.7098 64.8456L64.9955 53.711Z" fill="#161819"/>
</g>
<defs>
<clipPath id="clip0_6495_41325">
<rect width="100" height="100" rx="17.1429" fill="white"/>
</clipPath>
</defs>
</svg>
